import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { Category } from './category'

export class CategoriesRepository extends BaseRepository<Category> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.financialApiUrl + '/categories', token, cache)
    }

    async addDefaults() {
        const { json, statusCode, message } = await this.request.get(
            this.config.financialApiUrl + '/categories/add-defaults?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
